module.exports = __webpack_public_path__ + "static/media/trieste-17.64651400.jpg";